import React from 'react';
import { useTranslation } from 'react-i18next';

import { GuardrailSettingsState } from '../../../../../gamma-api';
import IbInput from '../../../../components/common/IbInput';
import IbSwitch from '../../../../components/common/IbSwitch';
import IbTypography from '../../../../components/common/IbTypography';
import { ITEM_CLASS_NAME } from '../../../../components/common/TypedStepModal/const';
import { GuardrailDetectorSettings } from '../shared/utils';

export interface ICommonDetectorParametersProps {
  detector: GuardrailDetectorSettings;
  onChange: (patch: Partial<GuardrailDetectorSettings>) => void;
  onStateChange: (state: GuardrailSettingsState) => void;
}

const CommonDetectorParameters: React.FC<ICommonDetectorParametersProps> = ({ detector, onChange, onStateChange }) => {
  const { t } = useTranslation();

  const onEnabledChange = (checked: boolean) => {
    onStateChange(checked ? GuardrailSettingsState.Enabled : GuardrailSettingsState.Disabled);
  };

  const onNameChange = (value: string) => {
    onChange({ name: value });
  };

  return (
    <>
      <div className={ITEM_CLASS_NAME}>
        <IbTypography>
          <IbSwitch
            checked={detector.state === GuardrailSettingsState.Enabled}
            size="small"
            onChange={onEnabledChange}
          />
          <IbTypography.Paragraph strong type="secondary">
            {t('Agent: Guardrails: Step: Enabled: Title')}
          </IbTypography.Paragraph>
        </IbTypography>
      </div>
      <div className={ITEM_CLASS_NAME}>
        <IbTypography.Paragraph strong type="secondary">
          {t('Agent: Guardrails: Masking: Detector: Name')}
        </IbTypography.Paragraph>
        <IbInput value={detector.name} onChange={onNameChange} />
      </div>
    </>
  );
};

export default CommonDetectorParameters;
